import styled from "styled-components/macro";
import { theme } from "../../styles/theme";

export const Wrapper = styled.div<{ flexEnd: boolean }>`
  background: ${theme.colors.bgSecondary};

  & > div {
    margin: 0 auto;
    max-width: 1360px;
    padding: 46px 80px;
    display: flex;
    flex-direction: ${(props) => (props.flexEnd ? "row-reverse" : "row")};
    justify-content: space-between;
    @media (max-width: 930px) {
      padding: 46px 40px;
    }
    @media (max-width: 850px) {
      padding: 46px 20px;
    }
    @media (max-width: 811px) {
      flex-direction: ${(props) =>
        props.flexEnd ? "column-reverse" : "column"};
      align-items: center;
    }
    @media (max-width: 425px) {
      & button {
        width: 100%;
      }
    }
  }
`;

export const VideoBlock = styled.div<{ flexEnd: boolean; preview: string }>`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.flexEnd ? "flex-end" : "flex-start")};
  margin: ${(props) => (props.flexEnd ? "0 0 0 20px" : "0 20px 0 0")};
  align-items: center;

  & video {
    object-fit: cover;
    height: 280px;
    max-width: 420px;
    width: 100%;
    border-radius: 8px;
    background-size: cover;
    height: 100%;
  }

  & > div {
    overflow: hidden;
    border-radius: 8px;
    position: relative;
    max-width: 420px;
    height: 100%;
    width: 100%;
    @media (max-width: 811px) {
      max-width: 100%;
    }
  }

  & > div > div {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 15;
    //height: 280px;
    border-radius: 8px;
    background: transparent url(${(props) => props.preview}) 50% 50% / cover
      no-repeat;

    &:after {
      position: absolute;
      height: 100%;
      width: 100%;
      background: rgba(255, 255, 255, ${(props) => (props.flexEnd ? 0.0 : 0)});
      content: "";
    }

    @media (max-width: 811px) {
      top: 34px;
      height: 100%;
    }
  }

  @media (max-width: 811px) {
    display: flex;
    justify-content: center;
    margin: ${(props) => (props.flexEnd ? "0" : "0 0 20px 0")};
    & video {
      margin-top: ${(props) => (props.flexEnd ? "34px" : "0")};
      max-width: 100%;
      height: 80%;
    }
  }
  @media (max-width: 425px) {
    & video {
      max-width: 100%;
      height: 80%;
    }
  }
`;

export const ContentSection = styled.div`
  max-width: 660px;
  width: 100%;

  & div {
    font-size: 32px;
    color: ${theme.colors.text};
    margin-bottom: 24px;
  }
  & div:first-child {
    font-weight: 600;
    font-size: 32px;
    color: ${theme.colors.text};
    margin-bottom: 24px;
  }

  & ul li {
    margin: 8px 0;
  }

  & div + div {
    font-size: 20px;
    color: ${theme.colors.textDimmed};
  }

  @media (max-width: 811px) {
    & div {
      font-size: 28px;
    }

    & div + div {
      font-size: 18px;
    }
  }
`;

export const PlayButton = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 300;
  height: 84px;
  width: 84px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media (max-width: 811px) {
    top: calc(50% - 20px);
    transform: translate(-50%, -50%);
  }
`;

export const Triangle = styled.div`
  &,
  &:before,
  &:after {
    width: 30px;
    height: 30px;
  }
  & {
    top: calc(50% - 15px);
    left: calc(50% - 22px);
    overflow: hidden;
    position: absolute;
    border-radius: 20%;
    transform: rotate(120deg) skewY(30deg) scaleX(0.866);
    cursor: pointer;
    pointer-events: none;
  }
  &:before,
  &:after {
    position: absolute;
    background: ${theme.colors.primary};
    pointer-events: auto;
    content: "";
  }
  &:before {
    border-radius: 20% 20% 20% 53%;
    transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%)
      skewX(30deg) scaleY(0.866) translateX(-24%);
  }
  &:after {
    border-radius: 20% 20% 53% 20%;
    transform: scaleX(1.155) skewY(-30deg) rotate(-30deg) translateY(-42.3%)
      skewX(-30deg) scaleY(0.866) translateX(24%);
  }

  /** extra styles to show how it works **/
`;
